module.exports = __webpack_public_path__ + "82d5319eed17190c07e226f1b977d3ec.png";